var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('el-result',{attrs:{"icon":"info","subTitle":"您访问的链接/页面不可用，请返回重试","title":"当前页面走丢了"}},[_c('template',{slot:"extra"},[_c('a',{attrs:{"href":"/"}},[_vm._v("返回首页")])])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }